<script lang="ts">
	import type { Snippet } from 'svelte';

	let { children }: { children: Snippet } = $props();
</script>

<div class="flex flex-col mt-4">
	<h1 class="self-center text-6xl">
		{@render children()}
	</h1>
</div>
